import { apiClient } from '@/shared/api/client';

/**
 * Authenticated CSV download. Export endpoints sit behind auth:sanctum, so a
 * plain <a href> (no Bearer header) always got 401 — fetch as a blob through
 * apiClient and trigger the save client-side instead.
 */
export async function downloadCsv(
  path: string,
  params: Record<string, unknown> | undefined,
  filename: string
): Promise<void> {
  const res = await apiClient.get(path, { params, responseType: 'blob' });
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
